import * as React from "react";
import { isEmpty, map, map as _map } from "lodash"
import { TabConfig } from "../../utils/TabManager"
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { EventNames, ITabVisitTrackerProps } from "../../utils/EventTrackerConstants";
import { Tracker } from "../../utils/Tracker";

export interface TabsHeaderProps {
    tabs: TabConfig[],
    activeTab: TabConfig,
    updateActiveTab: (tab: TabConfig, tabIdx: number) => any,
    updateActiveSubTab?: (tab: TabConfig, subTabIdx: number) => any,
    trackerEvents?: ITabVisitTrackerProps
}

const TabsHeader = (props: TabsHeaderProps): JSX.Element => {

    const [isExpanded, setExpanded] = React.useState<boolean>(false);
    const [activeTabIndex, setActiveTabIndex] = React.useState<number>();

    const updateActiveTab = (activeTab: TabConfig, index: number) => {
        //if (activeTab.subComponents && activeTab.subComponents.length > 0) return;
        //TODO: add changes here for dropdown tabs
        LocalStorageUtils.setClickEvents({ section: activeTab.display })
        props.trackerEvents && Tracker.track(EventNames.Tab_Visit, { section: activeTab.display, ...props.trackerEvents })
        props.updateActiveTab(activeTab, index)
        //activeTabIndex && setActiveTabIndex(null);
        isExpanded && setExpanded(false);
    }

    const updateSubActiveTab = (activeSubTab: TabConfig, index: number) => {
        props.updateActiveSubTab(activeSubTab, index)
        //activeTabIndex && setActiveTabIndex(null);
        // setExpanded(false);
    }

    const toggleExpanded = () => {
        setExpanded(isExpanded => !isExpanded);
    }

    const checkSubTabActive = () => {
        let exist = false;
        props.tabs.forEach((tab: TabConfig) => {
            if (tab.childTabs && tab.childTabs.includes(props.activeTab)) {
                exist = true;
            }
        })

        return exist;
    }

    const getDropdownTabs = (tab: TabConfig, className: string): JSX.Element => {
        const tabItemMargin = isExpanded ? { marginLeft: '9px', marginRight: '9px' } : {};
        return <div className={className} onClick={toggleExpanded} style={tabItemMargin}>
            <div className={"tabs-title"} style={isExpanded ? { background: '#f1f5f8', padding: 15 } : {}}> <span>{tab.display}</span><img src="/images/icons/down-arrow.svg" alt="down" /> </div>
            <div className={`tab-sub-tabs ${!isExpanded ? "collapsed" : ""}`}>
                <div className="dummy-nav-shadow" />
                {map(tab.childTabs, (t: TabConfig, subIndex: number) => {
                    let subTabClass = "tab-sub-tabs__tab"
                    if (props.activeTab.id === t.id) {
                        subTabClass += " activeSubTab";
                    }
                    return <div className={subTabClass} onClick={(e) => { updateSubActiveTab(t, subIndex) }}>{t.display}</div>
                }
                )}
            </div>
        </div>
    }

    return (
        <div className={"tabs-container"}>
            {
                _map(props.tabs, (item, index) => {
                    let tabClasses = "tab-item";
                    if (props.activeTab.id === item.id || (!isEmpty(item.childTabs) && checkSubTabActive())) tabClasses += " active";
                    return isEmpty(item.childTabs) ?
                        <div className={tabClasses} key={item.id} id={item.tabName} onClick={() => updateActiveTab(item, index)}>{item.display}</div>
                        : getDropdownTabs(item, tabClasses)
                })
            }
        </div>
    )
}

export default TabsHeader;

/*
_map(props.tabs, (item, index) => {
                    let tabClasses = "tab-item";
                    if (props.activeTab.id === item.id || activeTabIndex === index) tabClasses += " active";
                    return <div className={tabClasses} key={item.id} id={item.tabName} onClick={() => { isEmpty(item.subComponents) ? updateActiveTab(item, index) : toggleExpanded() }}>{isEmpty(item.subComponents) ? item.display : getDropdownTabs(item, index)}</div>
                })
*/